import { useState } from "react";
import { useStoneTypeActions } from "@/hooks/stone-types/useStoneTypeActions";

type ConfirmActionType = {
    type: "archive" | "restore";
    stoneTypeId: string;
    stoneTypeName: string;
};

export const useConfirmationDialog = (onSuccess: () => void) => {
    const [isOpen, setIsOpen] = useState(false);
    const [confirmAction, setConfirmAction] = useState<ConfirmActionType | null>(null);
    const { handleArchive, handleRestore, isLoading } = useStoneTypeActions();

    const openDialog = (action: ConfirmActionType) => {
        setConfirmAction(action);
        setIsOpen(true);
    };

    const closeDialog = () => {
        setIsOpen(false);
        setTimeout(() => setConfirmAction(null), 200);
    };

    const handleConfirm = async () => {
        if (!confirmAction) return;

        try {
            if (confirmAction.type === "archive") {
                await handleArchive(confirmAction.stoneTypeId);
            } else {
                await handleRestore(confirmAction.stoneTypeId);
            }
            onSuccess();
            closeDialog();
        } catch (error) {
            console.error(`Error ${confirmAction.type} stone type:`, error);
        }
    };

    return {
        isOpen,
        confirmAction,
        isLoading,
        openDialog,
        closeDialog,
        handleConfirm,
    };
}; 